(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('au-card')) {
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    class AuCard extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-au-track]');
        this.dots = [...this.querySelectorAll('.au-card__dots span')];
        this.index = 0;
        this.startFam = this.querySelector('[data-au-swatch][aria-pressed="true"]')?.dataset.fam || '';
        const slides = () => this.track ? [...this.track.children].filter(s => !s.hidden).length : 0;
        const warm = () => {
          if (this.warmed) return;
          this.warmed = true;
          this.querySelectorAll('.au-card__img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
        };
        this.addEventListener('pointerenter', warm, { once: true });
        this.addEventListener('focusin', warm, { once: true });
        this.track?.addEventListener('touchstart', warm, { once: true, passive: true });
        let frame = 0;
        this.track?.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const width = this.track.clientWidth || 1;
            const next = Math.max(0, Math.min(slides() - 1, Math.round(this.track.scrollLeft / width)));
            if (next !== this.index) { this.index = next; this.paint(); }
          });
        }, { passive: true });
        this.addEventListener('click', event => {
          const prev = event.target.closest('[data-au-prev]');
          const next = event.target.closest('[data-au-next]');
          const swatch = event.target.closest('[data-au-swatch]');
          if (prev || next) {
            event.preventDefault();
            warm();
            const count = slides();
            this.go(((this.index + (next ? 1 : -1)) % count + count) % count);
            return;
          }
          if (swatch) {
            event.preventDefault();
            this.pick(swatch);
          }
        });
      }
      go(index) {
        if (!this.track) return;
        this.index = index;
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
        this.paint();
      }
      paint() {
        const visible = this.track ? [...this.track.children].filter(s => !s.hidden).length : this.dots.length;
        this.dots.forEach((dot, i) => { dot.hidden = i >= visible; dot.classList.toggle('is-on', i === this.index); });
      }
      pick(swatch) {
        this.querySelectorAll('[data-au-swatch]').forEach(item => item.setAttribute('aria-pressed', String(item === swatch)));
        const main = this.querySelector('.au-card__img--main');
        const fam = swatch.dataset.fam || '';
        this.dataset.fam = fam;
        if (main && swatch.dataset.src) {
          if (swatch.dataset.srcset) main.srcset = swatch.dataset.srcset;
          main.src = swatch.dataset.src;
        }
        // G1: only this metal; a finish without its own photo shows the calm "coming soon" state
        const soon = this.querySelector('.au-card__soon');
        if (soon) soon.hidden = !!swatch.dataset.src;
        if (main) main.style.visibility = swatch.dataset.src ? '' : 'hidden';
        this.track?.querySelectorAll('.au-card__slide:not(.au-card__slide--main)').forEach(s => { const f = s.dataset.auFam || ''; s.hidden = !swatch.dataset.src || (f !== '' && f !== 'neutral' && f !== fam); });
        const hover = this.querySelector('.au-card__img--hover');
        if (hover) hover.hidden = fam !== this.startFam;
        const price = this.querySelector('[data-au-price]');
        if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;
        this.querySelectorAll('[data-au-card-link]').forEach(link => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('variant', swatch.dataset.variant);
          link.href = url.pathname + url.search;
          link.dataset.analyticsVariantId = swatch.dataset.variant;
        });
        if (this.index !== 0) this.go(0);
      }
    }
    customElements.define('au-card', AuCard);
  }
  } catch(e) { console.error(e); }
})();

})();
